import { Star } from "lucide-react";
import { useState } from "react";

// Peças da avaliação do pedido, usadas na página do link (/review/{token}) e
// no pop-up do cardápio, para as duas ficarem iguais (24/10/2026).

export const EMOJIS = ["", "😠", "😕", "😐", "🙂", "🤩"];
export const EMOJI_LABEL = ["", "Péssimo", "Ruim", "Ok", "Bom", "Excelente"];

/**
 * Resolve a cor primária do tenant pra um valor CSS aplicável.
 * Aceita:
 *  - "24 100% 50%"   (HSL split — formato do sistema interno)
 *  - "hsl(24 100% 50%)"
 *  - "#ff5e00"
 *  - "rgb(255, 94, 0)"
 * Fallback: laranja padrão (#f97316).
 */
export function resolvePrimary(raw) {
  if (!raw || typeof raw !== "string") return { color: "#f97316", hslSplit: null };
  const trimmed = raw.trim();
  if (trimmed.startsWith("#") || trimmed.startsWith("rgb") || trimmed.startsWith("hsl")) {
    return { color: trimmed, hslSplit: null };
  }
  // HSL split "H S% L%"
  if (/^\d+(\.\d+)?\s+\d+(\.\d+)?%\s+\d+(\.\d+)?%$/.test(trimmed)) {
    return { color: `hsl(${trimmed})`, hslSplit: trimmed };
  }
  return { color: trimmed, hslSplit: null };
}

export function StarRow({ value, onChange, disabled, primary, tamanho = "w-11 h-11 sm:w-14 sm:h-14" }) {
  const [hover, setHover] = useState(0);
  const active = hover || value || 0;
  return (
    <div className="flex flex-col items-center gap-2">
      <div
        className="flex gap-2 sm:gap-3"
        onMouseLeave={() => setHover(0)}
      >
        {[1, 2, 3, 4, 5].map((n) => {
          const filled = n <= active;
          return (
            <button
              key={n}
              type="button"
              disabled={disabled}
              onMouseEnter={() => !disabled && setHover(n)}
              onClick={() => !disabled && onChange(n)}
              className={`transition-transform ${disabled ? "cursor-default" : "hover:scale-125 active:scale-100"}`}
              aria-label={`${n} estrela${n > 1 ? "s" : ""}`}
            >
              <Star
                className={`${tamanho} transition-all ${
                  filled ? "drop-shadow-lg" : "text-zinc-300 dark:text-zinc-700"
                }`}
                strokeWidth={1.5}
                style={filled ? { fill: primary, color: primary } : undefined}
              />
            </button>
          );
        })}
      </div>
      <div className="h-7 text-base font-bold transition-opacity">
        {active > 0 ? (
          <span style={{ color: primary }}>
            {EMOJIS[active]} {EMOJI_LABEL[active]}
          </span>
        ) : (
          <span className="text-zinc-400 text-sm font-normal">Toque para avaliar</span>
        )}
      </div>
    </div>
  );
}

